<div *ngIf="showViewHTMLComponent">
  <form #miFormulario method="post" action="{{urlAgregarDescuento}}" target="_blank">
    <input type="hidden" name="tipoIdIca" value="{{tipoId}}"/>
    <input type="hidden" name="nroIdIca" value="{{nroId}}"/>
  </form>
</div>